import Vue from "vue";
import Router from "../router";

export default class OpenGraph extends Vue {

  static generateBreadcrumb(breadcrumbs: any): any {
   const itemListElement:any=[];
   let i=1;
   for(const breadcrumb of breadcrumbs){
       let link = ''
       if(i !== breadcrumbs.length){

           link = window.location.origin+breadcrumb.link
       }else{
           link = window.location.origin+Router.currentRoute.fullPath
       }
      const element = {
          "@type": "ListItem",
          "item": link,
          "name": breadcrumb.text,
          "position": i
      }
      i++;
        itemListElement.push(element)
    }


    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": itemListElement
  }

  }

  static generateProduct(product: any): any {


      return {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": product.name,
          /*"brand": {
              "@type": "Brand",
              "name": "Air France"
          },*/
          "description": product.description,
          "image": [
              product.pictureCover.src
          ],
          "sku": product.sku,
          "offers" : {
              "@type" : "Offer",
              "price" : product.defaultOffer.discountPrice.taxIncluded?product.defaultOffer.discountPrice.taxIncluded:product.defaultOffer.price.taxIncluded,
              "priceCurrency" : "EUR",
              "url" : window.location.origin+Router.currentRoute.fullPath,
              "itemCondition" : "https://schema.org/NewCondition",
              "availability" : "https://schema.org/InStock"
          },
      }
  }
/*
* "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "bestRating": "5",
              "worstRating": "0",
              "reviewCount": "3"
          },
* {
                  "@type": "Review",
                  "author": {
                      "@type": "Person",
                      "name": "Jean-pascal B."
                  },
                  "datePublished": "19/12/2021",
                  "reviewBody": "\u0022produit conforme a l'annonce\u0022",
                  "reviewRating": {
                      "@type": "Rating",
                      "bestRating": "5",
                      "ratingValue": "5",
                      "worstRating": "0"
                  }

              }
* */
}
